(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["707-nail-measurements"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nana-size-options')) {
    customElements.define('nana-size-options', class extends HTMLElement {
      connectedCallback() {
        if (!this.sizingConnected) {
          this.addEventListener('change', () => this.updateSizingRoute());
          this.sizingConnected = true;
        }
        this.updateSizingRoute();
      }
      updateSizingRoute() {
        const route = this.querySelector('[data-sizing-route]:checked')?.dataset.sizingRoute;
        const panel = this.querySelector('[data-sizing-panel]');
        const info = this.querySelector('[data-sizing-kit-info]');
        if (!panel || !info) return;
        panel.disabled = route !== 'known';
        panel.hidden = route !== 'known';
        info.hidden = route !== 'kit';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["707-sizing-viewer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nana-sizing-viewer')) {
  customElements.define('nana-sizing-viewer', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.stage = this.querySelector('.nana-kit-stage');
      this.sheet = this.querySelector('.nana-kit-sheet');
      this.x = -8;
      this.y = -18;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.stage.addEventListener('pointerdown', event => {
        if (event.isPrimary === false || event.button !== 0) return;
        cancelAnimationFrame(this.frame);
        this.pointer = { id: event.pointerId, px: event.clientX, py: event.clientY, x: this.x, y: this.y, touch: event.pointerType === 'touch', dragging: false };
      }, options);
      this.stage.addEventListener('pointermove', event => {
        const p = this.pointer;
        if (!p || p.id !== event.pointerId) return;
        const dx = event.clientX - p.px;
        const dy = event.clientY - p.py;
        if (!p.dragging) {
          if (Math.abs(dx) < 6 || (p.touch && Math.abs(dy) > Math.abs(dx))) return;
          p.dragging = true;
          this.stage.setPointerCapture(event.pointerId);
          this.stage.setAttribute('data-dragging', '');
        }
        if (event.cancelable) event.preventDefault();
        this.y = p.y + dx * 360 / Math.max(this.stage.clientWidth, 240);
        this.x = Math.max(-25, Math.min(25, p.x - dy * .15));
        this.paint();
      }, options);
      const release = event => {
        if (!this.pointer || this.pointer.id !== event.pointerId) return;
        this.pointer = null;
        this.stage.removeAttribute('data-dragging');
        if (this.stage.hasPointerCapture(event.pointerId)) this.stage.releasePointerCapture(event.pointerId);
      };
      window.addEventListener('pointerup', release, options);
      ['pointercancel', 'lostpointercapture'].forEach(type => this.stage.addEventListener(type, release, options));
      this.stage.addEventListener('keydown', event => {
        const changes = { ArrowLeft: -30, ArrowRight: 30 };
        if (event.key in changes) { event.preventDefault(); this.turnTo(this.y + changes[event.key], this.x); }
        if (event.key === 'Home') { event.preventDefault(); this.face('front'); }
      }, options);
      this.querySelectorAll('[data-kit-side]').forEach(button => button.addEventListener('click', () => this.face(button.dataset.kitSide), options));
      this.paint();
    }
    face(side) {
      const base = side === 'back' ? 180 : 0;
      const target = base + 360 * Math.round((this.y - base) / 360);
      this.turnTo(target, 0);
    }
    turnTo(targetY, targetX) {
      cancelAnimationFrame(this.frame);
      const startX = this.x;
      const startY = this.y;
      if (this.reduced.matches) { this.x = targetX; this.y = targetY; this.paint(); return; }
      const start = performance.now();
      const step = now => {
        const t = Math.min(1, (now - start) / 380);
        const eased = 1 - Math.pow(1 - t, 3);
        this.x = startX + (targetX - startX) * eased;
        this.y = startY + (targetY - startY) * eased;
        this.paint();
        if (t < 1) this.frame = requestAnimationFrame(step);
      };
      this.frame = requestAnimationFrame(step);
    }
    paint() {
      this.sheet.style.transform = `rotateX(${this.x}deg) rotateY(${this.y}deg)`;
      const front = Math.cos(this.y * Math.PI / 180) >= 0;
      this.querySelector('[data-kit-front]').setAttribute('aria-hidden', String(!front));
      this.querySelector('[data-kit-back]').setAttribute('aria-hidden', String(front));
      this.querySelectorAll('[data-kit-side]').forEach(button => button.setAttribute('aria-pressed', String((button.dataset.kitSide === 'front') === front)));
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.controller?.abort();
      this.controller = null;
      this.pointer = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
